import React from "react";
import { cellGrow } from "constants/styles";
import { gridContainer } from "constants/styles";

const DEFAULT_CLASSES = {
  list: "grid-container ma0 pa0 list"
};

const GridViewWrapper = ({
  models,
  loadCount,
  ModelComponent,
  customClasses
}) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  return (
    <ul className={classes.list}>
      {models.slice(0, loadCount).map((model, modelIx) => {
        return (
          <li key={model.id || modelIx} className={classes.item}>
            <ModelComponent {...model} />
          </li>
        );
      })}
      <style jsx>{cellGrow}</style>
      <style jsx>{gridContainer}</style>
    </ul>
  );
};
export default GridViewWrapper;
